<template>
  <section>
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="160px"></qx-custom-form>
  </section>
</template>

<script>
export default {
  data () {
    return {
      baseForm: {
        form: [
          {
            label: '实际控制人身份证',
            value: 'identificationPicture',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            default: [],
            attr: {
              limit: 1,
            },
          },
          {
            label: '实际控制人姓名',
            value: 'actualController',
            type: 'input',
          },
          {
            label: '实际控制人身份证号',
            value: 'identification',
            type: 'input',
          },
          {
            label: '实际控制人联系方式',
            value: 'actualControllerPhone',
            type: 'input',
          },
        ],
        rules: {
          identificationPicture: [
            { required: true, message: '请选择实际控制人身份证', trigger: 'blur' },
          ],
          actualController: [
            { required: true, message: '请输入实际控制人姓名', trigger: 'blur' },
          ],
          identification: [
            { required: true, message: '请输入实际控制人身份证号', trigger: 'blur' },
          ],
          actualControllerPhone: [
            { required: true, message: '请输入实际控制人联系方式', trigger: 'blur' },
            { validator: this.checkMobile, trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async sub () {
      const formData = await this.$refs.baseForm.sub();
      if (formData) {
        if (formData.identificationPicture && formData.identificationPicture.length) {
          formData.identificationPicture = formData.identificationPicture[0].id;
        }
        console.log(formData);
      }
      return formData;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
